
import IconArrowRight from '../icons/IconArrowRight.vue';
import IconArrowRightSmall from '../icons/IconArrowRightSmall.vue';
export default {
  components: { IconArrowRight, IconArrowRightSmall },
  props: {
    image: {
      type: String,
      required: true
    },
    role: {
      type: String,
      required: true
    },
    location: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    citation: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    }
  }
};
